export default __webpack_public_path__ + "static/media/Logo.6d2d0465.jpg";